import React from 'react';
import styles from './Typeface.module.css';

const Typeface = () => {
  return (
    <div className={styles.typeface}>
      <h3>Urbanist</h3>
      <div className={styles.sample}>Aa</div>
      <span>typeface</span>
    </div>
  );
};

export default Typeface;